import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_SHARED_SERVICE_PASSENGERS](state, data) {
    state.allSharedServicePassengers = data
  },
}
